import log from "loglevel";
import {
  apiCoreEndpoint,
  apiThemeEndpoint,
  forceAlenzaConfigPage,
} from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getConfigService = (request: t.GetConfigRequestType) => {
  let GET_CONFIG_API_ENDPOINT = `${apiCoreEndpoint}/config`;
  if (request.id) {
    log.debug("Action is requesting config key by ID...");
    GET_CONFIG_API_ENDPOINT += `/${request.id}`;
  } else if (request.keyName) {
    log.debug("Action is requesting config key by Key Name...");
    GET_CONFIG_API_ENDPOINT += `/key/${request.keyName}`;
  } else {
    throw {
      error: {
        message: "ID or Key Name not passed to Config Key request",
      },
    };
  }
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_CONFIG_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_CONFIG_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getConfigsService = (request?: t.GetConfigsRequestType) => {
  const GET_CONFIG_API_ENDPOINT = `${apiCoreEndpoint}/config`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_CONFIG_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_CONFIG_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const getConfigDefaultService = (
  request: t.GetConfigDefaultRequestType
) => {
  let GET_CONFIG_DEFAULT_API_ENDPOINT = apiCoreEndpoint; // Default
  /**
   * If this is a non-Alenza core deployment, the config endpoint will have
   * an indicator within the endpoint. This is necessary in order for the API
   * to appripriatly retrieve configurate details from the server application's *.conf files
   */
  if (forceAlenzaConfigPage === "true") {
    log.info(
      "Forcing Config Default Request to use Alenza API instead of Theme API ..."
    );
    GET_CONFIG_DEFAULT_API_ENDPOINT = apiCoreEndpoint;
  } else if (request.theme && request.theme.toLowerCase() !== "alenza") {
    GET_CONFIG_DEFAULT_API_ENDPOINT = apiThemeEndpoint;
  }
  GET_CONFIG_DEFAULT_API_ENDPOINT += `/config/default/`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_CONFIG_DEFAULT_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_CONFIG_DEFAULT_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const addConfigKeyService = (request: t.CreateConfigKeyRequestType) => {
  log.info("addConfigKeyService Request: " + JSON.stringify(request));
  const ADD_CONFIG_KEY_API_ENDPOINT = `${apiCoreEndpoint}/config`;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(ADD_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, ADD_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    })
    .catch((error) => {
      return {
        error: {
          message: "Unable to process request",
        },
      };
    });
};

export const modifyConfigKeyService = (
  request: t.ModifyConfigKeyRequestType
) => {
  log.info("modifyConfigKeyService Request: " + JSON.stringify(request));
  const keyId = request.id;
  const MODIFY_CONFIG_KEY_API_ENDPOINT = `${apiCoreEndpoint}/config/${keyId}`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  return fetch(MODIFY_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, MODIFY_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};

export const deleteConfigKeyService = (
  request: t.DeleteConfigKeyRequestType
) => {
  log.info("deleteConfigKeyService Request: " + JSON.stringify(request));
  const keyId = request.id;
  const DELETE_CONFIG_KEY_API_ENDPOINT = `${apiCoreEndpoint}/config/${keyId}`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(DELETE_CONFIG_KEY_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, DELETE_CONFIG_KEY_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
